import { Pill } from "src/base-components/Pill";
import { BeMappedNode } from "src/constants/NodeDataTypes";
import { getNodeIconFromNode } from "src/constants/NodeIcons";
import { NODE_TYPE } from "src/constants/NodeTypes";
import { Tooltip } from "src/design-system/Tooltip";

export const NodePill: React.FC<{ node: BeMappedNode }> = ({ node }) => (
  <Tooltip placement="bottom" title={node.data.label} asChild>
    <Pill size="sm" variant="gray" fullWidth>
      {node.type === NODE_TYPE.SQL_DATABASE_CONNECTION_NODE ? (
        <div className="-ml-px h-6 w-6">{getNodeIconFromNode(node, "sm")}</div>
      ) : (
        <div className="-ml-px h-4 w-4">{getNodeIconFromNode(node, "sm")}</div>
      )}
      <Pill.Text>{node.data.label}</Pill.Text>
    </Pill>
  </Tooltip>
);
